/* eslint-disable */
import React from 'react';
import LegalPage from '../components/LegalPage';

const TermsConditions = () => (
  <LegalPage eyebrow="THE MAISON" title="Terms &amp;" italicTail="Conditions.">
    <p>Welcome to Velouva. By accessing or purchasing from our website, you agree to be bound by these Terms &amp; Conditions.</p>

    <h2>1. Eligibility</h2>
    <p>You must be at least 18 years old, or use the website under the supervision of a parent or legal guardian.</p>

    <h2>2. Product Information</h2>
    <p>We make every effort to display product colours, descriptions, and images accurately. However, actual colours may vary due to screen settings, lighting conditions, and individual perception.</p>

    <h2>3. Pricing</h2>
    <ul>
      <li>All prices are displayed in Indian Rupees (INR).</li>
      <li>Prices may change without prior notice.</li>
      <li>We reserve the right to correct pricing errors at any time.</li>
    </ul>

    <h2>4. Orders</h2>
    <ul>
      <li>Orders are subject to acceptance and availability.</li>
      <li>We reserve the right to cancel orders due to stock shortages, payment issues, suspected fraud, or pricing errors.</li>
      <li>Refunds for cancelled orders will be processed to the original payment method.</li>
    </ul>

    <h2>5. User Conduct</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the website for unlawful purposes.</li>
      <li>Attempt unauthorised access to our systems.</li>
      <li>Submit false or misleading information.</li>
    </ul>

    <h2>6. Intellectual Property</h2>
    <p>All website content including logos, product names, images, graphics, and text are the exclusive property of Velouva and may not be copied or reproduced without written permission.</p>

    <h2>7. Limitation of Liability</h2>
    <p>Velouva shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or website.</p>

    <h2>8. Governing Law</h2>
    <p>These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Pune, Maharashtra.</p>
  </LegalPage>
);

export default TermsConditions;
